<script>
import NewHolidays from "@/components/NewHolidays";

export default {
    name: "AddHolidays",
    components: { NewHolidays },
    emits: ["holidaysUpdated"],
    props: {
        preExisting: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            dates: {},
            holidays: [],
        };
    },
    methods: {
        updateHolidays(holidays) {
            this.holidays = holidays;

            this.$storage.setStorageSync("holidays", this.holidays);

            this.$emit("holidaysUpdated", this.holidays);
        },
    },
    mounted() {
        this.dates = this.$storage.getStorageSync("dates");
        this.holidays = this.$storage.getStorageSync("holidays");
    },
};
</script>

<template>
    <h2>Holidays</h2>
    <NewHolidays
        :startDate="dates?.start?.plain"
        :endDate="dates?.end?.plain"
        @updated="updateHolidays"
        :default-holidays="holidays"
        :existing-holidays="preExisting"
        start-holiday-label="Holiday start date (optional)"
        end-holiday-label="Holiday end date (optional)"
    />
</template>

<style scoped>
.added-classes-container {
    top: 47px !important;
}

h2 {
    margin-bottom: 3rem;
}
</style>
